import apiClient from "./apiClient";

/**
 * Extracts a user-friendly error message from an Axios error
 */
const extractErrorMessage = (error, defaultMsg = "An error occurred. Please try again.") => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (typeof error?.response?.data === "string" && error.response.data.trim()) {
    return error.response.data;
  }
  if (typeof navigator !== "undefined" && !navigator.onLine) {
    return "You are currently offline. Please check your internet connection.";
  }
  if (error?.code === "ECONNABORTED" || error?.message?.toLowerCase().includes("timeout")) {
    return "Request timed out. The server took too long to respond. Please try again.";
  }
  if (!error?.response) {
    return "Network error. Unable to connect to server. Please check your internet connection.";
  }
  return error?.message || defaultMsg;
};

/**
 * Fetch all colleges for dropdown
 */
export const GetColleges = async () => {
  try {
    const response = await apiClient.get("college");
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: extractErrorMessage(error, "Failed to load colleges."),
      data: [],
    };
  }
};

/**
 * Fetch departments by collegeId for cascading dropdown
 */
export const GetDepartmentsByCollege = async (collegeId) => {
  try {
    const response = await apiClient.get(`department?collegeId=${collegeId}`);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: extractErrorMessage(error, "Failed to load departments."),
      data: [],
    };
  }
};

export const RegisterStudent = async (v) => {
  try {
    const response = await apiClient.post("user", v);
    return response.data;
  } catch (error) {
    if (error.response?.data && typeof error.response.data === "object") {
      return {
        ...error.response.data,
        status: error.response.status,
      };
    }
    return {
      success: false,
      message: extractErrorMessage(error, "Registration failed. Please try again."),
      status: error.response?.status,
    };
  }
};

export const SendOtp = async (v) => {
  try {
    const response = await apiClient.post("user/otp", v);
    return response.data;
  } catch (error) {
    if (error.response?.data && typeof error.response.data === "object") {
      return {
        ...error.response.data,
        status: error.response.status,
      };
    }
    return {
      success: false,
      message: extractErrorMessage(error, "Unable to send OTP. Please try again."),
      status: error.response?.status,
    };
  }
};

export const ValidateOtp = async (v) => {
  try {
    const response = await apiClient.post("user/validate", v);
    return response.data;
  } catch (error) {
    if (error.response?.data && typeof error.response.data === "object") {
      return {
        ...error.response.data,
        status: error.response.status,
      };
    }
    return {
      success: false,
      message: extractErrorMessage(error, "Failed to validate OTP. Please try again."),
      status: error.response?.status,
    };
  }
};


